import React from "react";
import PropTypes from "prop-types";

const BlogListTwo = ({ data, StyleVar = '' }) => {
  
    const title = data.title?.rendered || data.title || 'Untitled';
    const link = data.link || data.acf?.article_link || '#';
    const content = data.content?.rendered || data.acf?.article_content || data.excerpt?.rendered || '';
    const featuredImage = data.featured_image || data.acf?.article_image || '';
    const isExternal = /^https?:\/\//.test(link);
    

    const stripHtmlAndLimit = (html, limit = 150) => {
        if (!html) return '';
        
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const text = temp.textContent || temp.innerText || '';
        
        return text.length > limit ? text.substring(0, limit) + '...' : text;
    };


    const handleImageError = (e) => {
        e.target.src = 'https://via.placeholder.com/400x250?text=No+Image';
        e.target.alt = 'Placeholder image';
    };

    return (
        <div className={`rn-card ${StyleVar}`}>
            <div className="inner blog_content">
                <div className="thumbnail">
                    <a
                        href={link}
                        aria-label={`Read the post: ${title}`}
                        className="image"
                        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                        {featuredImage ? (
                            <div 
                                style={{
                                    width: '100%',
                                    height: '250px',
                                    backgroundColor: '#403B3B',
                                    borderRadius: '8px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    overflow: 'hidden',
                                    padding: '8px',
                                    boxSizing: 'border-box'
                                }}
                            >
                                <img 
                                    src={featuredImage} 
                                    alt={title}
                                    onError={handleImageError}
                                    loading="lazy"
                                    style={{
                                        maxWidth: '100%',
                                        maxHeight: '100%',
                                        objectFit: 'contain',
                                        borderRadius: '4px',
                                        transition: 'transform 0.3s ease'
                                    }}
                                    onMouseOver={(e) => e.target.style.transform = 'scale(1.02)'}
                                    onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                                />
                            </div>
                        ) : (
                            <div 
                                style={{
                                    width: '100%',
                                    height: '250px',
                                    backgroundColor: '#403B3B',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '8px',
                                    // color: '#acacac',
                                    fontSize: '14px'
                                }}
                            >
                                No Image Available
                            </div>
                        )}
                    </a>
                </div>
                
                <div className="content">
                    <h4 className="title">
                        <a
                            href={link}
                            aria-label={`Read the post: ${title}`}
                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                            style={{ 
                                textDecoration: 'none',
                                color: 'inherit',
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                lineHeight: '1.4'
                            }}
                        >
                            {title}
                        </a>
                    </h4>
                    
                    {content && (
                        <p 
                            className="description"
                            style={{
                                fontSize: '14px',
                                lineHeight: '1.6',
                                marginTop: '10px',
                                marginBottom: '15px',
                            }}
                        >
                            {stripHtmlAndLimit(content, 120)}
                        </p>
                    )}
                    
                    {/* Additional metadata */}
                    {data.date && (
                        <div 
                            className="post-meta" 
                            role="group"
                            aria-label="Post metadata"
                            style={{ 
                                fontSize: '13px', 
                                marginTop: '10px',
                                borderTop: '1px solid #eee',
                                paddingTop: '10px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}
                        >
                            <span>Published: {data.date}</span>
                            {data.author && (
                                <span style={{ fontWeight: '500' }}>
                                    By: {data.author}
                                </span>
                            )}
                        </div>
                    )}
                    
                    <div 
                        className="read-more" 
                        style={{ 
                            marginTop: '15px',
                            textAlign: 'center'
                        }}
                    >
                        <a
                            href={link}
                            className="btn-read-more"
                            style={{
                                color: '#007cba',
                                textDecoration: 'none',
                                fontSize: '14px',
                                fontWeight: '600',
                                padding: '8px 16px',
                                border: '1px solid #007cba',
                                borderRadius: '4px',
                                display: 'inline-block',
                                transition: 'all 0.3s ease'
                            }}
                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                            aria-label={`Read full article: ${title}`}
                            onMouseOver={(e) => {
                                e.target.style.backgroundColor = '#007cba';
                                e.target.style.color = 'white';
                            }}
                            onMouseOut={(e) => {
                                e.target.style.backgroundColor = 'transparent';
                                e.target.style.color = '#007cba';
                            }}
                        >
                            Read Full Article →
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

BlogListTwo.propTypes = {
    data: PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.shape({
                rendered: PropTypes.string
            })
        ]),
        content: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.shape({
                rendered: PropTypes.string
            })
        ]),
        excerpt: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.shape({
                rendered: PropTypes.string
            })
        ]),
        link: PropTypes.string,
        featured_image: PropTypes.string,
        date: PropTypes.string,
        author: PropTypes.string,
        acf: PropTypes.shape({
            article_image: PropTypes.string,
            article_link: PropTypes.string,
            article_content: PropTypes.string
        })
    }).isRequired,
    StyleVar: PropTypes.string
};

export default BlogListTwo;
